import { render } from "./PostNickName.vue?vue&type=template&id=4f081b18&ts=true"
import script from "./PostNickName.vue?vue&type=script&setup=true&lang=ts"
export * from "./PostNickName.vue?vue&type=script&setup=true&lang=ts"

import "./PostNickName.vue?vue&type=style&index=0&id=4f081b18&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/communityTalk/PostNickName.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4f081b18"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4f081b18', __exports__)) {
    api.reload('4f081b18', __exports__)
  }
  
  module.hot.accept("./PostNickName.vue?vue&type=template&id=4f081b18&ts=true", () => {
    api.rerender('4f081b18', render)
  })

}


export default __exports__